import { Form } from 'react-bootstrap';
import { useApp } from '../../../../hook/app.hook';
import { Section, Question, Option } from '../../../../response/test.response';
import { CustomTextView } from '../../../../view/custom-text.view';
import { useId } from 'react';
import { getLanguageContent } from '../../../../util/language.util';
import { QuestionFormat } from '../../../../enum/question-format';

const SingleChoiceComponent = () => {
  const id = useId();
  const { testRes, saveQuestionResponse, language } = useApp();

  const activeSection = testRes.sectionList.filter(
    (section: Section) => section.active,
  )[0];
  const question = activeSection.questionList.filter(
    (question: Question, index: number) => {
      return question.active;
    },
  )[0];

  return (
    <div>
      {question.optionList?.map((option: Option, index: number) => {
        return (
          <Form.Check
            type="radio"
            key={`question_${question.id}_${option.id}_${id}`}
            id={`question_${question.id}_${option.id}_${id}`}
            label={
              <CustomTextView
                initData={getLanguageContent(option.value, language)}
                format={
                  question.format.length > 0
                    ? question.format
                    : QuestionFormat.RICH_HTML
                }
              />
            }
            name={question.id}
            value={option.id}
            defaultChecked={option.selected}
            checked={option.selected}
            className="mb-3 bg-white d-flex align-items-center p-0 mcq-inputs border border-levenderblue rounded w-100"
            onChange={(e: any) => {
              saveQuestionResponse(question.id, null, [option.id]);
            }}
          />
        );
      })}
    </div>
  );
};

export default SingleChoiceComponent;
